/**
 * File: FibController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import imagePopup from '../views/popup/imagePopup.html'
import passagePopup from '../views/popup/passagePopup.html'
class FibController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, CQuesConst, CONSTANTS, $compile, $mdDialog, $mdMedia, uploadService, randomColorService) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        /********** BASIC DETAILS *********/
        let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
        let userId = localStorageService.get("user_id")
        let USER_PATH = userId + "/question/"
        let schoolId = localStorageService.get("school_id")
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
        let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
        let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
        let SAVE_URL = CQuesConst.API_CREATE_FIB
        $scope.option_limit = CQuesConst.OPTION_LIMIT;
        $scope.explain_limit=CQuesConst.ANS_EXPLANATION_LIMIT;
        $scope.questionImage = [];
        $scope.descImage = [];
        $scope.explanationImage = [];
        $scope.isLatex = false
        $scope.content_editor_id = userId;
        let questionData = {}
        $scope.question = "";
        let errorCount = 0;
        $scope.answers = [];
        //TO SET PASSAGE LIST
        var passageCallback = (resultObj) => {
            $scope.isPassagePresent = false;
            $scope.passages = []
            if (resultObj && resultObj.result && resultObj.result.data) {
                var result = resultObj.result.data.passage ? resultObj.result.data.passage : []
                if (result) {
                    if (result.length > 0) {
                        $scope.isPassagePresent = true;
                        _.each(result, function (eachPas) {
                            if ($scope.selectedPassage_id === eachPas._id) {
                                eachPas["isSelected"] = true
                            } else {
                                eachPas["isSelected"] = false
                            }
                        })
                        $scope.passages = result
                    }
                    _.defer(() => {
                        $scope.$apply()
                    })
                }
            }
        }
        let authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId,
            user_id: userId
        }
        authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback)
        
        // TO DELETE SELECTED PASSAGE
        $scope.cancelSelectedPasssage = function () {

            $scope.selectedPassage = null
            _.each($scope.passages, function (eachPas) {
                eachPas.isSelected=false
            })
          }

        $scope.onQuesLoad = function () {
            if ($scope.qn_desc === undefined) {
                return
            }
            let question = $scope.qn_desc;
            let fibArchiveOptions = question.split('_')
            let loadedQst = ""
            let querySl = "#answer"
            let myEl = angular.element(document.querySelector(querySl));
            myEl.empty();
            $scope.answers = []
            _.each(fibArchiveOptions, function (option, index) {
                if (index === (fibArchiveOptions.length - 1)) {
                    loadedQst = " " + option.trim()
                    myEl.append(loadedQst)
                    return
                }
                if (questionData && questionData.answer && questionData.answer[index]) {
                    $scope.answers.push({
                        "color": randomColorService.getRandomColor(),
                        "desc": questionData.answer[index].desc,
                        "explanation": questionData.answer[index].explanation
                    })
                } else {
                    $scope.answers.push({
                        "color": randomColorService.getRandomColor()
                    })
                }
                loadedQst = " " + option.trim() + " "
                myEl.append(loadedQst)
                myEl.append($compile('<md-input-container class="fibArchiveAnswer"><label>Enter Answer</label><textarea md-maxlength="{{option_limit}}" txt-maxlength="{{option_limit}}" type="text" ng-model="answers[' + index + '].desc"></textarea><p class="errorMessage">{{errors["answers.' + index + '.desc"]}}</p></md-input-container>')($scope))
            })
        }
        let editQuestion = $scope.$parent.$parent.editQuestion
        if (editQuestion) {
            $scope._id = editQuestion._id;
            console.log($scope._id)
            $scope.qn_desc = editQuestion.qn_desc;
            $scope.questionImage = [];
            if (editQuestion.questionImg) {
                if (Array.isArray(editQuestion.questionImg)) {
                    $scope.questionImage = editQuestion.questionImg
                } else {
                    $scope.questionImage.push(editQuestion.questionImg)
                }
            }
            if (editQuestion && editQuestion.answer) {
                $scope.onQuesLoad()
                $scope.answers = _.map(editQuestion.answer, function (ans) {
                    ans["color"] = randomColorService.getRandomColor()
                    return ans;
                })
            }
            $scope.created_dt = editQuestion.created_dt;
            $scope.content_editor_id = editQuestion.content_editor_id;
            $scope.selectedPassage_id = editQuestion.passage_id;
            if ($scope.selectedPassage_id) {
                $scope.selectedPassage = editQuestion.passage_detail;
            }
        }
        let imageViewType = "";
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            }
            imageViewType = ""
            $scope.imageArray = []
        };
        //Image upload for question
        $scope.questionImgUpload = function (file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function (fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                        if (result.url) {
                            $scope.questionImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        //DIALOG CONTROLLER FOR IMAGE
        var imageDialogCtrl = function ($scope, $mdDialog, imageViewType, imageDetails) {
            $scope.fileUrl = PREVIEW_URL
            $scope.isPassage = false;
            $scope.title = imageDetails.title;
            $scope.imageArray = imageDetails.images;
            $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false

            $scope.deleteImage = function (imageIndex) {
                $scope.imageArray.splice(imageIndex, 1)
            }
            $scope.cancelDialog = function () {
                $mdDialog.cancel();
                if (imageViewType === 'question') {
                    $scope.questionImage = $scope.imageArray
                } else if (imageViewType === 'explan') {
                    $scope.explanationImage = $scope.imageArray
                } else if (imageViewType === 'answer') {
                    $scope.descImage = $scope.imageArray
                }
                $scope.imageArray = []
            };
        }

        //Open dialog to view image
        $scope.openDialog = (imageType, index, desc) => {
            let imageDetails;
            if (imageType === 'question') {
                imageDetails = {
                    title: "FIB - Question Image",
                    images: $scope.questionImage
                }
            }
            else if (imageType === 'passage') {
                imageDetails = {
                    title: "SA - Passage Image",
                    images: $scope.selectedPassage.passage_image,
                    isPassage: true
                }
            }
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
                    imageViewType: imageType,
                    imageDetails: imageDetails
                },
                template: imagePopup,
                controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }

        var setPassage = () => {
            $scope.selectedPassage = _.find($scope.passages, function (pas) {
                return pas.isSelected
            })
        }

        //DIALOG CONTROLLER FOR PASSAGE
        var passageDialogCtrl = function ($scope, $mdDialog, passages) {
            $scope.passages = passages
            $scope.fileUrl = PREVIEW_URL
            $scope.isArray = function (obj) {
                return Array.isArray(obj);
            }
            /*
             * Function to cancel dialog to select passage
             */
            $scope.cancelPassage = function () {
                $mdDialog.cancel();
                setPassage()
            };



            /*
             * Function to select passage
             */
            $scope.selectPassage = function (passage_id) {
                _.each($scope.passages, function (eachPas) {
                    if (eachPas._id != passage_id) {
                        eachPas.isSelected = false;
                    }
                })
                $scope.cancelPassage()
            }

        }



        /*
         * Function to open dialog to select passage
         */
        $scope.openPassage = () => {
            if (!$scope.passages) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('No Passage')
                        .textContent('Passages not loaded.Try after some time.')
                        .ariaLabel('Passage Dialog')
                        .ok('Ok')
                );
            }
            else {
                if ($scope.passages.length == 0) {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title('No Passage')
                            .textContent('No passages added yet. Please add passage and link it')
                            .ariaLabel('Passage Dialog')
                            .ok('Ok')
                    );
                }

                else {
                    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                    $mdDialog.show({
                        locals: {
                            passages: $scope.passages
                        },
                        template: passagePopup,
                        controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: useFullScreen
                    })
                }
            }
        }

        //Adding OWQ question from UI
        $scope.$on('addFibQuestion', function () {
            $scope.errors = {}
            let details = localStorageService.get("questionDetails")
            let question = details.question
            let activityErrorCount = details.errorCount;
            //Validation  
            if ($scope.qn_desc == null || $scope.qn_desc == undefined || $scope.qn_desc == "") {
                $scope.errors.qn_desc = "Question is required";
                activityErrorCount++;
            } else if ($scope.qn_desc.split('_').length < 2) {
                $scope.errors.qn_desc = "Enter a valid question";
                activityErrorCount++;
            }
            if ($scope.answers) {
                _.each($scope.answers, function (answer, index) {
                    if (answer.explanation == null || answer.explanation == undefined || answer.explanation == "") {
                        $scope.errors["answers." + index + ".explanation"] = "Explanation is required"
                        activityErrorCount++;
                    }
                    else if (answer.explanation && answer.explanation.length > $scope.explain_limit) {
                        $scope.errors["answers." + index + ".explanation"] = "Explanation does not exceed " + CQuesConst.ANS_EXPLANATION_LIMIT + " characters"
                        activityErrorCount++;
                    }
                    if (answer.desc == null || answer.desc == undefined || answer.desc == "") {
                        $scope.errors["answers." + index + ".desc"] = "Answer is required"
                        activityErrorCount++;
                    }
                })
            }
            if (activityErrorCount === 0) {
                $scope.$parent.isSaveClicked = true;
                let answerArr = []
                _.each($scope.answers, function (ans, index) {
                    let ansObj = {
                        "desc": ans.desc,
                        "explanation": ans.explanation
                    }
                    answerArr.push(ansObj)
                })
                let obj = {
                    "_id": $scope._id,
                    "question_theme_id": question.theme._id,
                    "question_theme_name": question.theme.name,
                    "qn_desc": '' + $scope.qn_desc,
                    "answer": answerArr,
                    "strand": question.strand,
                    "tag": question.tag,
                    "wave": question.wave,
                    "isLatex": $scope.isLatex,
                    "level": question.level,
                    "subject_id": question.subject_id,
                    "school_id": question.school_id,
                    "questionImg": $scope.questionImage,
                    "session_id": question.session_id,
                    "batch_id": question.batch_id,
                    "class_id": question.class_id,
                    "curriculum_id": question.curriculum_id,
                    "xlink": question.link_theme,
                    "cognitive_skills": question.cognitive_skill,
                    "isNotAddToQp": question.isNotAddToQp,
                    "is_traditional_activity": question.is_traditional_activity,
                    "qp_id": question.qp_id,
                    "created_dt": $scope.created_dt,
                    "content_editor_id": $scope.content_editor_id,
                    "activity_id": question.activity_id,
                    "user_id": userId,
                    "passage": $scope.selectedPassage,
                    "teaching_plan_id": question.teaching_plan_id
                }
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    let result = resObj.result
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        $rootScope.resetValues()
                        if (question.is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: question.qp_id
                            })
                            toastr.success("Question Saved successfully");
                        }else if(question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== ""){
                            $state.go('formatQp', {
                                resourceId: question.activity_id
                            })
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession()
                            }
                        }
                    } else {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        toastr.error("Network Error")
                    }
                    _.defer(() => { $scope.$apply() })
                })
            } else {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                toastr.error("Please fill all mandatory fields")
            }
        })


        /************** LINK QUESTION TO PASSAGE : END ****************/


        //On destroy function
        this.$onDestroy = () => { }

    }
}

export default FibController;



// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/fibController.js